// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"226":"82dd8e1e4650982b","353":"e6a5c4058079918b","3238":"ffcd7203012dd224","4071":"9465f2e7f02ec8b8","6271":"88962a57518622de","6643":"5d3548054d2adfce","9474":"710d31d2bf5cfe1c"}[chunkId] + ".js";
};